export default "/ItemGetOnly.glb";